var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BC1535;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,20c0,11.05-8.95,20-20,20h0C8.95,40,0,31.05,0,20v0C0,8.95,8.95,0,20,0h0C31.05,0,40,8.95,40,20L40,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.2,32.31c0.39-0.36,2.01-2.04,2.87-5.53l0.65-2.65c0.6,0.63,1.45,1.05,2.33,1.27 c3.58,0.88,7.05-2.95,7.95-6.63c1.27-5.15-1.36-9.7-5.72-10.76c-5.02-1.23-10.94,1.22-12.38,7.11c-0.51,2.07-0.34,5.2,2.47,6.69 c0.29,0.15,0.64-0.01,0.72-0.32l0.39-1.59c0.04-0.18-0.03-0.37-0.17-0.5c-1-0.91-1.23-2.39-0.89-3.78 c0.98-3.98,5.07-5.62,8.56-4.76c3.02,0.74,4.86,3.83,4.01,7.31c-0.61,2.49-2.34,5.23-4.83,4.62c-1.49-0.36-1.66-1.82-1.26-3.47 l0.91-3.73c0.24-0.96-0.35-1.94-1.31-2.17c-0.96-0.24-2.49,0.45-2.97,2.44c-0.29,1.16-0.05,2.1,0.39,2.71l-1.83,7.49 c-0.85,3.45-0.21,5.68-0.02,6.21"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.9a0876918778a0128c81c4342473ce80.svg";
export { ForwardRef as ReactComponent };